import { Controller } from "@hotwired/stimulus"

// Filtra filas de una tabla por texto, ignorando mayúsculas y tildes.
export default class extends Controller {
  static targets = ["input", "row", "count"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.normalize(this.inputTarget.value)
    let visible = 0

    this.rowTargets.forEach((row) => {
      const match = query === "" || this.normalize(row.textContent).includes(query)
      row.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = this.countTarget.textContent.replace(/^\d+/, String(visible))
    }
  }

  normalize(text) {
    return text.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")
  }
}
